var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "toolTip", class: _vm.bemBlock },
    [
      _vm.styles
        ? _c("style", {
            tag: "component",
            domProps: { innerHTML: _vm._s(_vm.styles) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { "data-tooltip-type": _vm.type } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }